const colors = {
  red: "#e60000",
  redBerry: "#990000",
  guardsmanRed: "#bd0000",
  alizarinCrimson: "#e82626",
  electricRed: "#E60000",
  freeSpeechRed: "#d80000",
  maroon: "#71000",
  maroon2: "#850000",
  sealBrown: "#440000",
  aestheticMaroon: "#7E0E0D",
  chineseSilver: "#ccc",
  islamicGreen: "#009900",
  green: "#428600",
  greenDark: "#438700",
  greenHaze: "#01AF50",
  grassGreen: "#478603",
  verdunGreen: "#335100",
  pistachio: "#a8b600",
  limeade: "#30b601",
  christi: "#53a10b",
  gainsboro2: "#dcdcdc",
  conifer: "#92D051",
  feijoa: "#A6D088",
  amber: "#FFC000",
  tacao: "#F4B083",
  magentaRed: "#FE0000",

  seance: "#9c2aa0",
  amethyst: "#c649ca",
  finn: "#5e2750",
  finnDark: "#2f1328",
  buddhaGold: "#a8b400",
  supernova: "#fecb00",
  tangerine: "#eb9700",
  tangerineDark: "#ed9700",
  tangerineLight: "#efbc62",
  turquoiseDark: "#075162",
  orange: "#eb5400",
  blueLagoon: "#007c92",
  blueLagoonDark: "#00515f",
  cerulean: "#00b0ca",
  sepraBlue: "#004c58",
  provincialpink: "#fef2f2",
  skyCream: "#f7fdfd",
  turquoiseBlue: "#5fcddd",
  cornflowerBlue: "#007e92",
  abbey: "#4a4d4e",
  ironsideGray: "#6f6e6b",
  gravelGray: "#818181",
  bleach: "#F4F4F4",
  porcelain: "#fcfdfd",
  gray79: "#c9c9c9",
  vividBlue: "#00afca",
  purple: "#703060",
  lightPurple: "#d7c9d3",
  mediumPurple: "#5f2951",
  darkPurple: "#37172f",
  lightPink: "#e5bfbf",
  almond: "#f0f0ca",
  skyBlue: "#bfdde5",
  darkGold: "#848458",
  weirdGreen: "#147e90",
  goldenTainoi: "#ffcc66",
  blueSea: "#66a8cc",
  lynch: "#73859f",
  ebonyClay: "#2b333f",
  heather: "#bfc7d3",
  mediumLightCyanblue: "#5897fb",
  cyanBlue: "#3875d7",
  sapphireBlue: "#1D6A76",
  chathamsBlue: "#145A68",
  easternBlue: "#007990",
  blumine: "#17616e",
  paradiso: "#36808B",
  bluminea: "#165b6a",
  thatchGreen: "#48431e",
  cola: "#251900",
  aquamarineBlue: "#7fd7e4",
  schooner: "#928579",
  kabul: "#695d52",
  vividViolet: "#9c31a3",
  lemon: "#ebeb00",
  weirdGrey: "#757e82",
  warmGrey: "#979797",
  bouquet: "#ae92a6",
  darkPink: "#ad5389",
  strongCyan: "#017c92",
  pacificBlue: "#00b5c5",
  citron: "#a1b826",
  brightRed: "#ae0000",
  vividRed: "#f90000",
  fireEngineRed: "#c11f25",
  deepMaroon: "#820000",
  sherpablue: "#004e59",
  allports: "#156b7d",

  //grayscale
  black: "#000000",
  white: "#ffffff",
  whiteSmoke: "#efefef",
  whiteSmokeLight: "#f5f5f5",
  gray66: "#a8a8a8",
  grayLight: "#6d6d6d",
  mineShaft: "#333333",
  mineShaftLight: "#3d3d3d",
  mineShaftDark: "#2a2a2a",
  mineShaftDarker: "#222222",
  mineShaftDarkest: "#2b2b2b",
  tundora: "#434343",
  tundoraDark: "#494949",
  mercury: "#e5e5e5",
  charcoalGray: "#404041",
  doveGray: "#666666",
  doveGrayDarker: "#6a6a6a",
  dustyGray: "#999999",
  tenderGray: "#0000004D",
  silverChalice: "#afafaf",
  silverGray: "#cbcbcb",
  silver: "#cccccc",
  mercuryDark: "#e4e4e4",
  gallery: "#ebebeb",
  wildSand: "#f4f4f4",
  alabaster: "#fafafa",
  lightGray: "#d3d3d3",
  boulder: "#777777",
  hexGray: "#fcfcfc",
  scorpion: "#575757",
  pitchBlack: "#171717",
  alto: "#d8d8d8",
  snow: "#f9f9f9",
  gainsboro: "#dedede",
  dimTray: "#6c6c6c",
  mouseGray: "#f7f7f7",
  davysGray: "#555555",
  mediumGray: "#aaaaaa",
  emperor: "#4f4f4f",
  medGray: "#515151",
  darkGray: "#444444",
  caparolGray: "#888888",
  veryLightGray: "#eeeeee",
  lighterGray: "#dddddd",
  nightRider: "#303030",
  paynesGray: "#3e3e3f",
  bastille: "#2c2c2e",
  blackRussian: "#212123",
  shepherdsGray: "#464646",
  shark: "#282c33",
  bunker: "#0a0d12",
  codGay: "#101010",
  nero: "#232323",
  slateGrey: "#6C7B8A",
  riverBed: "#404A54",
  dimGray: "#707070"
};

export { colors };
